import { render, staticRenderFns } from "./OpStats.vue?vue&type=template&id=51dac100"
import script from "./OpStats.vue?vue&type=script&lang=js"
export * from "./OpStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports